import { render, staticRenderFns } from "./NewRegisterBonusSetting.vue?vue&type=template&id=0aaa0e38&"
import script from "./NewRegisterBonusSetting.vue?vue&type=script&lang=js&"
export * from "./NewRegisterBonusSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports